/**
 * FooterLinkSection - Reusable footer section component
 *
 * Renders a section with title and list of links.
 */

import { TextLink } from '@/modules/Frontend/UiBlocks'

import type { FooterSection } from '../../types'

interface FooterLinkSectionProps {
  data: FooterSection
}

/**
 * Renders a footer section with title and links
 */
export function FooterLinkSection({ data }: FooterLinkSectionProps) {
  return (
    <div className="flex flex-col gap-2 mb-5">
      <h3 className="font-poppins text-white uppercase font-bold text-sm">
        {data.title}
      </h3>
      <ul className="flex flex-col gap-1">
        {data.links.map((link) => (
          <li key={link.href} className="m-0">
            <TextLink
              href={link.href}
              title={link.title}
              external={link.external}
              variant="light"
              size="sm"
            >
              {link.title}
            </TextLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
